import { translateLanguage } from 'components';
import {
  Accounting,
  GiftCardContent,
  MySubscriptionContent,
  OnlineBookingContent,
  PurchaseOrder,
  StaffScheduleContent,
  UniversalSearch,
} from 'models';
import {
  localeCurrentDate,
  convertLocaleToUTCDate,
} from 'utilities/formatDate';
import { STRIPE_SUCCESS_TEST_CARD } from './utilities';

export const createCreditMemoDefaultValues = {
  [Accounting.PAYMENTTYPEID]: '',
  [Accounting.PAYMENTTYPE]: '',
  [Accounting.QTY]: 1,
  [Accounting.DATE]: localeCurrentDate,
  [Accounting.LOCATIONID]: '',
  [Accounting.TAX1]: 0,
  [Accounting.TAX2]: 0,
  [Accounting.TAX1NAME]: '',
  [Accounting.TAX2NAME]: '',
  [Accounting.SELECTITEM]: 'scanBarcode',
  [Accounting.DESCRIPTION]: '',
  [Accounting.SELECTTAX]: Accounting.WITHTAX,
  [Accounting.NOTES]: '',
  [Accounting.PATIENT]: '',
  [Accounting.PRICE]: 0,
  [Accounting.TOTAL]: 0,
  [Accounting.SCANBARCODE]: '',
  [Accounting.SOURCEID]: '',
  [Accounting.CREDITMEMODETAILS]: [],
  [Accounting.RECEIPTNUMBER]: '',
  [Accounting.CREDITMEMONUMBER]: '',
  [Accounting.CREDITMEMOITEMSTOTAL]: 0,
  [Accounting.NOTES2]: '',
  [Accounting.CREDITMEMOID]: 0,
  [Accounting.DEPOSITDATE]: convertLocaleToUTCDate(localeCurrentDate),
};

export const autoReplenishDefaultValues = {
  [Accounting.PURCHASEORDERLOCATION]: '',
  [Accounting.PRODUCTCATEGORIES]: [],
};

export const updateOrderQtyDefaultValues = {
  [Accounting.PURCHASEORDERPRODUCTS]: [],
  [PurchaseOrder.Validate]: false,
};

export const universalSearchDefaultValues = {
  [UniversalSearch.STARTDATE]: localeCurrentDate,
  [UniversalSearch.ENDDATE]: localeCurrentDate,
  [UniversalSearch.LOCATION]: 0,
  [UniversalSearch.GENDER]: '',
  [UniversalSearch.CITY]: '',
  [UniversalSearch.POSTALCODE]: '',
  [UniversalSearch.EMAIL]: '',
  [UniversalSearch.CALL]: '',
  [UniversalSearch.EMAILRADIO]: '',
  [UniversalSearch.CALLRADIO]: '',
  [UniversalSearch.MAIL]: '',
  [UniversalSearch.TEXTCONSENT]: '',
  [UniversalSearch.SELECTPROCEDURETYPE]: `${UniversalSearch.CROSSMARKETING}`,
  [UniversalSearch.SELECTITEM]: `${UniversalSearch.PROCEDURES}`,
  [UniversalSearch.AGEGREATER]: 0,
  [UniversalSearch.AGELESS]: 0,
  [UniversalSearch.AMOUNTGREATER]: 0,
  [UniversalSearch.AMOUNTLESS]: 0,
  [UniversalSearch.UNITSGREATER]: 0,
  [UniversalSearch.UNITSLESS]: 0,
  [UniversalSearch.SYRGREATER]: 0,
  [UniversalSearch.SYRLESS]: 0,
  [UniversalSearch.PHYSICIANID]: '',
  [UniversalSearch.SERVICEPROVIDER]: '',
  [UniversalSearch.AGENTSALES]: '',
  [UniversalSearch.DOCUMENTTYPE]: `${UniversalSearch.EXCEL}`,
  [UniversalSearch.TOTAL]: 0,
  [UniversalSearch.SEARCHITEMDETAILS]: [],
  [UniversalSearch.DESCRIPTION]: '',
  [UniversalSearch.HASHPROCEDURE]: 0,
  [UniversalSearch.HASHSKINCARE]: 0,
  [UniversalSearch.DONE]: '',
};

export const giftCardDefaultValues = {
  [Accounting.GIFTAMOUNT]: 0,
  [Accounting.GIFTCARDP]: [],
  [Accounting.STRIPEAMOUNT]: 0,
  [Accounting.STRIPETESTCARD]: STRIPE_SUCCESS_TEST_CARD,
  [Accounting.CURRENTBALANCE]: 0,
};

export const listGiftCardsDefaultValues = {
  [Accounting.REFID]: '',
  [Accounting.SENDNAME]: '',
  [Accounting.RCPNAME]: '',
  [Accounting.CARDSTATUS]: '',
  [Accounting.STATUSTYPE]: '',
  [Accounting.AMOUNT]: '',
};

export const giftCardTemplateDefaultValues = {
  [GiftCardContent.ENTERTITLE]: '',
  [GiftCardContent.MINEXPIRYMONTHS]: 0,
  [GiftCardContent.MAXEXPIRYMONTHS]: 0,
  [GiftCardContent.TERMSCONDITIONS]: '',
};

export const mySubscriptionOrderDefaultValues = {
  [MySubscriptionContent.ORDERID]: '',
  [MySubscriptionContent.CUSTOMER]: '',
  [MySubscriptionContent.DATECREATED]: localeCurrentDate,
  [MySubscriptionContent.OSTATUS]: '',
  [MySubscriptionContent.BILLINGADDRESS]: '',
  [MySubscriptionContent.SHIPPINGADDRESS]: '',
  [MySubscriptionContent.EMAILADDRESS]: '',
  [MySubscriptionContent.PHONENUMBER]: '',
  [MySubscriptionContent.ITEMSDETAIL]: [],
  [MySubscriptionContent.ITEMSTOTAL]: 0,
  [MySubscriptionContent.SHIPPINGTOTAL]: 0,
  [MySubscriptionContent.DISCOUNTTOTAL]: 0,
  [MySubscriptionContent.ORDERTOTAL]: 0,
  [MySubscriptionContent.PAIDCREDITCARD]: 0,
  [MySubscriptionContent.TOTALTAX]: 0,
  [MySubscriptionContent.TAXLABEL]: translateLanguage(
    `MySubscription.${MySubscriptionContent.TAXLABEL}`,
  ),
  [MySubscriptionContent.FEES]: 0,
  [MySubscriptionContent.STRIPEFEE]: 0,
  [MySubscriptionContent.STRIPEPAYOUT]: 0,
};

export const onlineBookingSearchDefaultValues = {
  [OnlineBookingContent.APPOINTMENTDATE]: new Date(),
  [OnlineBookingContent.LOCATIONID]: '',
  [OnlineBookingContent.PROCEDUREID]: '',
  [OnlineBookingContent.STAFFID]: '',
  [OnlineBookingContent.CATEGORY]: ''
};

export const onlineBookingAppointmentDefaultValues = {
  [OnlineBookingContent.FIRSTNAME]: '',
  [OnlineBookingContent.LASTNAME]: '',
  // [OnlineBookingContent.GENDER]: '',
  [OnlineBookingContent.EMAIL]: '',
  [OnlineBookingContent.DATEOFBIRTH]: null,
  [OnlineBookingContent.PHONENUMBER]: '',
};

export const initTime = {
  [StaffScheduleContent.FROM]: '',
  [StaffScheduleContent.TO]: '',
  [StaffScheduleContent.ISERROR]: false,
  [StaffScheduleContent.ERRORMESSAGE]: '',
  [StaffScheduleContent.LOCATIONID]: '',
};

export const initDays = [
  { [StaffScheduleContent.MON]: [] },
  { [StaffScheduleContent.TUE]: [] },
  { [StaffScheduleContent.WED]: [] },
  { [StaffScheduleContent.THU]: [] },
  { [StaffScheduleContent.FRI]: [] },
  { [StaffScheduleContent.SAT]: [] },
  { [StaffScheduleContent.SUN]: [] },
];

export const staffScheduleDefaultValues = {
  [StaffScheduleContent.STAFFID]: '',
  [StaffScheduleContent.STAFFNAME]: '',
  [StaffScheduleContent.WORKDAY]: [],
  [StaffScheduleContent.APPLYSAMETIME]: false,
  [StaffScheduleContent.SELECTWORKINGDAYLIST]: [
    {
      [StaffScheduleContent.DIFFERENTTIMESLOT]: initDays,
    },
    {
      [StaffScheduleContent.SAMETIMESLOT]: initDays,
    },
  ],
  // for Same Time Slot
  [StaffScheduleContent.SAMETIME]: [initTime],
};
